import { createFileRoute } from '@tanstack/react-router';
import { PricingPlanPagesWrapper } from '@/pages/billing/PricingPlanPagesWrapper';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/billing')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['billing.read', 'billing.manageSubscription', 'billing.managePayments', 'billing.manageAddons'],
		}),
	component: PricingPlanPagesWrapper,
});
